// AUTO-GENERATED by scripts/generate-theme.mjs. DO NOT EDIT BY HAND.

export type ThemeConfig = {
  primary: string;
  accent: string;
  warn: string;
  surface: string;
  surfaceVariant: string;
  onSurface: string;
  outline: string;
};

export const GENERATED_THEME: ThemeConfig = {
  primary: '#3455A1',
  accent: '#EC9C49',
  warn: '#E05229',
  surface: '#FFFFFF',
  surfaceVariant: '#F4F3F3',
  onSurface: '#0F1720',
  outline: '#D7DEEE'
};
